<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div class="data-title flex-space-between" slot="header">
          <p>Distro Tracks</p>
<!--          <TracksFilters />-->
          <DistroDialog />
        </div>

        <el-table :data="tracks.data" class="w100 distro-import" stripe>
         <el-table-column v-if="getColumns.includes('cover')" label="Cover" prop="cover" sortable>
            <template slot-scope="props">
              <el-image
                  :src="`${api}/${props.row.album.artwork.path}`"
                  fit="contain"
                  style="width: 50px; height: 50px"
                  class="avatar"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column v-if="getColumns.includes('title')" label="Release Title" sortable>
            <template slot-scope="props">
              {{ props.row.album.release_title }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('account')" label="Account" sortable>
            <template slot-scope="props">
              {{ props.row.album.user.email }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('tracks')" label="Tracks" prop="tracks" sortable>
            <template slot-scope="props">
              {{ props.row.album.tracks_count }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('artist')" label="Main Artists" prop="artist" sortable>
            <template slot-scope="props">
              {{ props.row.album.artist.name }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('created_at')" label="Published date" sortable>
            <template slot-scope="props">
              {{ moment(props.row.created_at).format('DD MMM YYYY') }}
            </template>
          </el-table-column>
          <el-table-column label="Start date" prop="date_start" sortable="custom">
            <template slot-scope="props">
              {{ props.row.date_start | date }}
            </template>
          </el-table-column>
          <el-table-column label="End date" prop="date_end" sortable="custom">
            <template slot-scope="props">
              {{ props.row.date_end | date }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('actions')" label="Actions" align="right" width="180">
            <template slot-scope="props">
              <el-tooltip v-if="getActions.includes('edit')" content="Edit" placement="top">
                <el-button type="warning" circle size="small" icon="el-icon-edit" @click="openModal(props.row)"></el-button>
              </el-tooltip>
              <el-tooltip v-if="getActions.includes('unpublish')" content="Unpublish" placement="top">
                <el-button type="danger" circle size="small" icon="el-icon-bottom" @click="unpublish(props.row.id)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination style="width: 700px; margin: auto"
                       background @size-change="sizeChange" @current-change="currentChange"
                       :current-page="tracks.current_page" :page-sizes="[10, 25, 50]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="tracks.total"
        ></el-pagination>

      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import moment from "moment";
import DistroDialog from '../components/DistroDialog.vue'
import TracksFilters from "@/modules/admin/new-releases/components/TracksFilters.vue";

export default {
  components: {TracksFilters, DistroDialog},

  data() {
    return {
      statuses: { '1': 'Incomplete', '2': 'Submitted', '3': 'Delivered', '4': 'Rejected', '5': 'Takedown' },
      moment,
      selectedTracks: [],
      selectedAll: false,
      api: process.env.VUE_APP_API_HOST,
    }
  },

  computed: {
    ...mapState('distro', ['trackStatus', 'pageSize', 'currentPage', 'tracks']),
    ...mapGetters('distro', ['getColumns', 'getActions']),
  },

  methods: {
    ...mapMutations('distro', ['setPageSize', 'setCurrentPage', 'setShowDialog', 'setTrack']),
    ...mapActions('distro', ['getTracks', 'download', 'unpublish']),

    async sizeChange(size) {
      this.setPageSize(size)
      await this.getTracks({ publish: true });
    },
    async currentChange(page) {
      this.setCurrentPage(page)
      await this.getTracks({ publish: true });
    },

    async downloadTracks() {
      const ids = this.totalSelected === this.tracks.total ? '*' : this.selectedTracks.join(',');
      await this.download(ids)

      this.selectedAll = false
      this.selectedTracks = []
    },
    openModal(track) {
      this.setTrack(JSON.parse(JSON.stringify(track)))
      this.setShowDialog(true)
    }
  },

  async created() {
    await this.getTracks({ publish: true });
  }
}
</script>

<style lang="scss">
.distro-import .checkbox-track span {
  width: 20px;
  height: 20px;
  border-color: #e55279;
}

.checkbox-track .el-checkbox__label {
  display: none;
}

.el-checkbox__inner::after {
  height: 10px;
  left: 7px;
}

.distro-import .checkbox-track {
  display: flex;
}
</style>